export { useAnalytics } from './useAnalytics';
export var ANALYTICS_CHANNEL = 'embeddedConfluence';